export const reelsets = {
    base: [
      [
          4, 13, 13, 11, 11, 5, 5, 9, 9, 9, 9, 9, 9, 9, 8, 8, 6, 7, 7, 7, 6, 11, 11, 13, 13, 13, 4, 11, 6, 6, 6, 10, 10, 10, 11, 10, 7, 7, 4, 8, 8,
          5, 5, 12, 12, 12, 13, 13, 6, 6, 10, 4, 7, 7, 8, 13, 10, 12, 12, 7, 7, 8, 8, 8, 12, 7, 7, 7, 6, 11, 5, 5, 5, 5, 3, 3, 3, 3, 8, 4, 11, 8,
          12, 7, 5, 10, 4, 4, 6, 6, 10, 4, 12, 12, 5, 7, 12, 6, 6, 5, 5, 5, 8, 8, 8, 8, 13, 13, 13, 4, 4, 4, 6, 6, 8, 8, 11, 11, 12, 7, 4, 10
      ],
      [
          7, 6, 5, 0, 12, 5, 5, 9, 9, 9, 9, 9, 9, 9, 6, 6, 1, 13, 13, 5, 10, 10, 11, 7, 7, 0, 1, 12, 12, 5, 13, 13, 7, 7, 8, 8, 8, 11, 7, 11, 0, 1,
          10, 13, 5, 5, 5, 8, 8, 6, 6, 6, 6, 7, 7, 7, 7, 11, 11, 12, 12, 12, 8, 8, 4, 4, 4, 8, 3, 3, 3, 3, 11, 7, 7, 7, 6, 12, 8, 8, 11, 11, 6, 6,
          4, 7, 10, 5, 5, 12, 4, 4, 0, 8, 8, 13, 13, 13, 4, 4, 4, 8, 8, 8, 6, 6, 6, 10, 12, 12, 5, 7, 13, 1, 8, 0, 10, 3, 3, 3, 3, 5, 5, 10, 13, 13,
          12, 11, 10, 0, 4, 4, 4, 6, 10, 11
      ],
      [
          11, 11, 13, 13, 0, 6, 9, 9, 9, 9, 9, 9, 9, 4, 4, 5, 5, 5, 10, 7, 7, 7, 7, 8, 8, 8, 8, 8, 5, 5, 0, 5, 5, 4, 10, 10, 10, 1, 12, 12, 11, 0,
          8, 4, 6, 6, 4, 4, 12, 6, 11, 11, 3, 3, 3, 3, 7, 7, 0, 8, 4, 4, 13, 5, 5, 8, 6, 1, 13, 7, 4, 13, 10, 10, 7, 4, 12, 13, 11, 11, 6, 6, 6, 8,
          11, 10, 13, 13, 7, 7, 7, 12, 12, 8, 8, 5, 5, 7, 13, 13, 13, 12, 1, 6, 11, 8, 8, 8, 8, 3, 3, 3, 3, 7, 7, 7, 0, 10, 10, 12, 12, 6, 6, 6, 6,
          4, 4, 0, 1, 12, 12, 5, 5, 6, 11, 8
      ],
      [
          6, 6, 13, 7, 4, 0, 8, 11, 11, 9, 9, 9, 9, 9, 9, 9, 6, 6, 1, 11, 11, 11, 4, 4, 4, 10, 12, 12, 12, 5, 8, 8, 7, 1, 5, 5, 5, 0, 10, 13, 13, 8, 8,
          7, 7, 1, 8, 8, 12, 3, 3, 3, 3, 8, 4, 4, 0, 5, 7, 5, 5, 6, 6, 6, 6, 13, 12, 13, 8, 8, 12, 10, 10, 13, 6, 6, 12, 8, 8, 8, 7, 10, 12, 10, 4, 8,
          0, 6, 6, 5, 12, 7, 7, 7, 8, 8, 0, 13, 1, 11, 7, 7, 5, 5, 5, 10, 10, 11, 11, 6, 13, 13, 13, 12, 4, 4, 7, 7, 7, 12, 4, 4, 11, 11, 10, 6, 5, 5,
          7, 0, 4, 13
      ],
      [
          11, 11, 5, 5, 13, 7, 7, 9, 9, 9, 9, 9, 9, 9, 13, 4, 4, 10, 10, 2, 8, 8, 7, 5, 5, 6, 6, 6, 4, 4, 12, 7, 8, 13, 13, 8, 8, 6, 13, 7, 7, 4, 8, 4,
          4, 4, 6, 2, 8, 11, 12, 12, 11, 5, 6, 8, 13, 6, 6, 5, 5, 12, 12, 10, 10, 11, 12, 12, 6, 10, 10, 6, 6, 5, 6, 10, 10, 12, 8, 8, 4, 4, 7, 13, 13,
          6, 5, 12, 12, 8, 8, 11, 11, 7, 7, 7, 7, 7, 8, 8, 8, 7, 7, 13, 11, 11, 11, 6, 10, 7, 13, 13, 8, 12, 5, 5, 5, 4, 4, 5
      ]
    ],
    freespins: [
      [
          4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 13, 13, 11, 11, 5, 5, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 8, 8, 6, 7, 7, 7, 6, 11, 11, 13, 13, 13, 4, 11, 6, 6, 6,
          9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 11, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 10, 7, 7, 4, 8, 8, 5, 5, 12, 12, 12, 13, 13, 6, 6, 10, 4,
          7, 7, 8, 13, 10, 12, 12, 7, 7, 8, 8, 8, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 12, 7, 7, 7, 6, 11, 5, 5, 5, 5, 8, 4, 11, 8, 12, 7, 5, 10, 4, 4, 6, 6,
          10, 4, 12, 12, 5, 7, 12, 6, 6, 5, 5, 5, 8, 8, 8, 8, 13, 13, 13, 4, 4, 4, 6, 6, 8, 8, 11, 11, 12, 7, 4, 10
      ],
      [
          7, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 6, 5, 0, 12, 5, 5, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 6, 6, 1, 13, 13, 5, 10, 10, 11, 7, 7, 0, 1, 12, 12, 5, 13,
          9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 13, 7, 7, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 8, 8, 8, 11, 7, 11, 0, 1, 10, 13, 5, 5, 5, 8, 8, 6, 6, 6, 6,
          0, 7, 7, 7, 7, 1, 1, 11, 11, 12, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 12, 12, 8, 8, 4, 4, 4, 8, 11, 7, 7, 7, 6, 12, 8, 8, 11, 11, 0, 6, 6, 4, 7, 1,
          10, 5, 5, 12, 4, 4, 0, 8, 8, 13, 13, 13, 4, 4, 4, 8, 8, 8, 6, 6, 6, 10, 12, 12, 5, 7, 13, 8, 0, 10, 5, 5, 10, 13, 13, 12, 11, 10, 0, 4, 4, 4,
          6, 10, 11
      ],
      [
          11, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 11, 13, 13, 0, 6, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 4, 4, 5, 5, 5, 10, 7, 7, 7, 7, 8, 8, 8, 8, 8, 5, 5, 0, 9, 9,
          9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 5, 5, 4, 10, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 10, 10, 1, 12, 12, 11, 0, 8, 4, 6, 6, 4, 4, 12, 6, 11, 11, 7, 7,
          0, 8, 4, 4, 13, 5, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 5, 8, 6, 1, 13, 7, 4, 13, 10, 10, 7, 4, 12, 0, 13, 11, 11, 6, 1, 6, 6, 8, 11, 10, 13, 13, 7,
          7, 7, 12, 12, 8, 1, 8, 5, 5, 7, 0, 13, 13, 13, 12, 1, 6, 11, 8, 8, 8, 8, 7, 7, 7, 0, 10, 10, 1, 1, 12, 12, 6, 6, 6, 6, 4, 4, 0, 12, 12, 5, 5,
          6, 11, 8
      ],
      [
          6, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 6, 13, 7, 4, 0, 8, 11, 11, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 6, 6, 1, 11, 11, 11, 4, 4, 4, 10, 12, 12, 12, 5, 8,
          9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 8, 7, 1, 5, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 5, 5, 0, 10, 13, 13, 8, 8, 7, 7, 1, 8, 8, 12, 8, 4, 4, 0, 5,
          7, 5, 5, 6, 6, 6, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 6, 13, 12, 13, 8, 8, 12, 0, 10, 10, 13, 6, 6, 12, 8, 8, 8, 7, 10, 12, 10, 4, 8, 0, 6, 6, 1, 5,
          12, 7, 7, 7, 8, 8, 0, 13, 1, 11, 7, 7, 5, 5, 5, 10, 10, 11, 11, 6, 1, 1, 13, 13, 13, 12, 0, 4, 4, 7, 7, 7, 12, 4, 4, 11, 11, 10, 6, 5, 5, 7,
          0, 4, 13
      ],
      [
          11, 11, 5, 5, 13, 7, 7, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 13, 4, 4, 10, 10, 2, 8, 8, 7, 5, 5, 6, 6, 6, 2, 4, 4, 12, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9,
          9, 9, 9, 7, 8, 13, 13, 8, 8, 2, 6, 6, 13, 7, 7, 7, 4, 4, 4, 6, 2, 8, 11, 12, 12, 11, 5, 6, 8, 8, 13, 6, 5, 12, 12, 10, 10, 11, 2, 12, 12, 6,
          10, 10, 6, 5, 6, 10, 10, 2, 12, 8, 8, 4, 4, 4, 13, 13, 6, 5, 12, 12, 2, 8, 8, 11, 11, 7, 7, 7, 7, 8, 8, 8, 2, 7, 7, 13, 11, 11, 11, 6, 10, 7,
          2, 13, 13, 12, 5, 5, 5, 4, 4, 5
      ]
    ]
};
